export default __webpack_public_path__ + "8e65be60b1b1c1ad82c7405d216e077a.svg";